var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('users-list',{attrs:{"request-path":_vm.requestUrls.user.add,"role-query":"Client","edit-fields":_vm.fields,"registration-fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }